import { Paper, PaperProps } from '@mantine/core';
import React from 'react';

interface CardProps extends PaperProps {
  children: React.ReactNode;
}

const Card: React.FC<CardProps> = ({
  children,
  radius = 'lg',
  py = 20,
  px = 16,
  withBorder = true,
  ...props
}) => {
  return (
    <Paper radius={radius} py={py} px={px} withBorder={withBorder} {...props}>
      {children}
    </Paper>
  );
};

export default Card;
